export default __webpack_public_path__ + "546b3db3caefc3b2a00fea80e1d64e47.svg";